import { useEffect, useRef, useState } from 'react';
import { connectRefinementList } from 'instantsearch.js/es/connectors';

/**
 * Connects a single Typesense refinement list to React state.
 * Returns the current facet items, the set of refined values, and a refine function.
 *
 * @param {object} search - The instantsearch instance
 * @param {string} attribute - The facet attribute to connect
 * @param {object} [options] - Options passed to the widget (limit, operator, etc.)
 * @returns {{ items: Array, refined: string[], refine: Function|null }}
 */
const useRefinementList = (search, attribute, options = {}) => {
  const [items, setItems] = useState([]);
  const [refined, setRefined] = useState([]);
  const refineRef = useRef(null);
  const mountedRef = useRef(false);

  useEffect(() => {
    if (!search || mountedRef.current) return;
    mountedRef.current = true;

    const widget = connectRefinementList((renderState) => {
      setItems(renderState.items);
      setRefined(
        renderState.items.filter((i) => i.isRefined).map((i) => i.value)
      );
      refineRef.current = renderState.refine;
    });

    search.addWidgets([
      widget({ attribute, limit: 100, operator: 'and', ...options }),
    ]);
  }, [search, attribute]);

  const refine = (value) => {
    if (refineRef.current) refineRef.current([value]);
  };

  return { items, refined, refine };
};

export default useRefinementList;
